export enum SelectedItemEnum {
  CHAT = "CHAT",
  GROUP = "GROUP",
  CONTACT = "CONTACT"
}
